import { Link } from "react-router-dom";

export const Logo = ({ light = false, className = "" }) => {
  const ink = light ? "#f5f2eb" : "#0f2d40";
  return (
    <Link to="/" data-testid="nav-logo-brand" className={`group flex items-center gap-2.5 ${className}`}>
      <svg
        width="38"
        height="24"
        viewBox="0 0 40 24"
        fill="none"
        className="transition-transform duration-500 group-hover:scale-105"
        aria-hidden="true"
      >
        <path
          d="M1 9 Q 6 2 11 9 T 21 9 T 31 9 T 39 9"
          stroke="#c85a32"
          strokeWidth="2.4"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M1 15 Q 6 22 11 15 T 21 15 T 31 15 T 39 15"
          stroke="#8ab48a"
          strokeWidth="2.4"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
      <span
        className="font-display text-[1.5rem] font-medium leading-none tracking-tight"
        style={{ color: ink }}
      >
        best<span style={{ color: "#c85a32" }}>price</span>
        <span style={{ opacity: 0.55 }}>·umago</span>
      </span>
    </Link>
  );
};
